module.exports = __webpack_public_path__ + "static/media/PDF_105.ce0bcdbe.pdf";